import {Component, OnInit} from '@angular/core';
import {navItems} from '../../_nav';
import {NavigationEnd, Router} from "@angular/router";
import {ProcessBuilderService} from "../../services/process-builder.service";

export class BreadcrumbItem {
  name: string;
  url: string;
  mode: string;
  active: boolean;

  constructor(name: string, url: string, active: boolean, mode: string) {
    this.name = name;
    this.url = url;
    this.active = active;
    this.mode = mode;
  }
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  public fullContainerInd = false;

  public breadcrumbItems: BreadcrumbItem[] = [];

  copyrightYear = (new Date()).getFullYear();

  constructor(private router: Router, private processBuilderService: ProcessBuilderService) {

    processBuilderService.processBuilderMode$.subscribe(processBuilderMode => {
      // console.log('default-layout: ' + processBuilderMode);
      // console.dir(processBuilderMode);
      if (processBuilderMode && processBuilderMode.name) {
        this.breadcrumbItems.pop();
        this.breadcrumbItems.push(new BreadcrumbItem('Process Builder', '/#/design/process/builder', false, 'tree'));
        this.breadcrumbItems.push(new BreadcrumbItem(processBuilderMode.name, '/#/design/process/builder', true, processBuilderMode.code));
      }
    });

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        // console.log('router event:');
        // console.dir(event);
        this.breadcrumbItems = [];

        this.breadcrumbItems.push(new BreadcrumbItem('Home', '/#/', false, undefined));

        // console.log(this.router.url);
        if (this.router.url) {
          switch (this.router.url) {
            case '/design/process/builder':
              this.breadcrumbItems.push(new BreadcrumbItem('Forms', '/#/design/forms', false, undefined));
              this.breadcrumbItems.push(new BreadcrumbItem('Process Builder', '/#/design/process/builder', true, undefined));
              break;
            case '/design/forms':
              this.breadcrumbItems.push(new BreadcrumbItem('Forms', '/#/design/forms', true, undefined));
              break;
            case '/design/import':
              this.breadcrumbItems.push(new BreadcrumbItem('Import', '/#/design/import', true, undefined));
              break;
            case '/theme/colors':
              this.breadcrumbItems.push(new BreadcrumbItem('Theme', '/#/theme', false, undefined));
              this.breadcrumbItems.push(new BreadcrumbItem('Colors', '/#/theme/colors', true, undefined));
              break;

          }

        }
        if (this.router.url && this.router.url === '/design/process/builder') {
          this.fullContainerInd = true;
        } else {
          this.fullContainerInd = false;
        }

      }
    })
  }


  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  ngOnInit(): void {
    // console.log('DefaultLayoutComponent.ngOnInit.navItems:');
    // console.dir(navItems);
  }

  onChangeMode(mode: string) {
    // console.log('onChangeMode.mode: ' + mode);
    if (mode && mode == 'tree') {
      this.breadcrumbItems.pop();
      this.breadcrumbItems.pop();
      this.breadcrumbItems.push(new BreadcrumbItem('Process Builder', '/#/design/process/builder', true, undefined));
      this.processBuilderService.processBuilderHome = true;
    }
  }
}
